module.exports = __webpack_public_path__ + "static/apple-touch-icon-76x76-11dfa2ecd1a9ae1f0978a8e4d618f3c8.png";